import Link from "next/link";
import styled from "@emotion/styled";

import { DESKTOP } from "@/themes/device";

export const ALink = styled(Link)`
  width: 100%;
  max-width: 100%;

  ${DESKTOP} {
    max-width: 370px;
  }
`;
